export default "__VITE_ASSET__C3Sadp6d__"